module.exports = __webpack_public_path__ + "pk.c519e9b1.svg";